<div class="click-catcher"
     [ngStyle]="{'top.px': clickCatcherPosition.y - 47, 'right.px': clickCatcherPosition.x }"
     (click)="close()">

</div>

<div class="modal-actions-menu" [ngStyle]="{'top.px': menuPosition.y, 'right.px': menuPosition.x}">
    <div *ngFor="let menuItem of setting.menuItems" class="menu-item" (click)="onMenuItemClick(menuItem)">
        <i class="fa" [ngClass]="menuItem.faIcon"></i> {{menuItem.label}}
    </div>
</div>
